<template>
    <div class="word-list">
        <div class="header">
            <span class="title">叢書類：</span>
            <a-select defaultValue="lucy" style="width: 120px" v-model="type" placeholder="請選擇">
                <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.desc}}</a-select-option>
            </a-select>
            <span class="title" style="margin-left:20px;">叢書名稱：</span>
            <a-input style="width:200px;" v-model="searchText"></a-input>
            <a-button type="primary" style="margin-left:20px;" size="small" @click="search">搜索</a-button>
        </div>
        <a-table
                rowKey="id"
                :dataSource="list"
                :loading="loading"
                :pagination="false">
            <a-table-column
                    title="叢書名稱"
                    dataIndex="title">

            </a-table-column>
            <a-table-column
                    title="叢書分類"
                    dataIndex="nounTypeDesc">

            </a-table-column>
            <a-table-column
                    title="上傳時間">
                <template slot-scope="item,row,index">
                    {{row.addTime | trans-date}}
                </template>
            </a-table-column>
            <a-table-column
                    title="叢書ID"
                    dataIndex="id">
            </a-table-column>
            <a-table-column
                    title="操作">
                <template slot-scope="sub,row,index">
                    <a-button @click="del(row)" style="margin-right:10px;" size="small">刪除</a-button>
                    <a-button @click="edit(row)" size="small">編輯</a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-pagination v-model="currentPage" :total="total" @change="currentChange" />

    </div>
</template>
<script>
    export default {
        data() {
            return {
                currentPage:1,
                searchText:'',
                list:[],
                loading:false,
                typeList:[],
                para:{
                    pageIndex:1,
                    pageSize:8,
                },
                type:'000',
                total:0
            }
        },
        methods: {
            getClaList(){
                let self=this;
                this.$http({
                    method: 'get',
                    url: '/manager/type/noun/list',
                }).then(function(res){
                    if(res.data && res.data.length){
                        self.typeList=res.data;
                    }else{
                        self.typeList=[]
                    }
                    self.typeList.unshift({id:'000',desc:'全部'})
                }).catch(err=>{
                    self.loading=false;
                })
            },
            getList(){
                let self=this;
                this.$http({
                    method: 'post',
                    url: '/manager/noun/list',
                    data:self.para
                }).then(function(res){
                    if(res.data && res.data.list){
                        self.list=res.data.list;
                    }else{
                        self.list=[]
                    }
                    self.total=res.data.totalRows;
                    self.currentPage=res.data.pageIndex;
                }).catch(err=>{
                    self.loading=false;
                })
            },
            search(){
                if(this.type!=='000'){
                    this.para.nounTypeId=this.type;
                }else{
                    delete this.para.nounTypeId;
                }
                if(this.searchText!==''){
                    this.para.title=this.searchText;
                }else{
                    delete this.para.title;
                }
                this.getList()
            },
            del(item){
                let self=this;
                this.$Confirm({
                    title:'確定刪除嗎？',
                    onOk(){
                        self.$http({
                            method: 'post',
                            url: '/manager/noun/delete',
                            data:{
                                id:item.id
                            }
                        }).then(function(res){
                            self.$Message.success('操作成功')
                            self.getList()
                        }).catch(err=>{
                        })
                    },
                    onCancel(){
                    }
                })
            },
            edit(item){
                this.$router.push({name:'addWord',query:{id:item.id}})
            },
            currentChange(val){
                this.para.pageIndex=val
                this.getList()
            }
        },
        created() {
            this.getClaList()
            this.getList();
            this.$emit('breadcrumbChange',['叢書管理','叢書列表'])
        },
    }
</script>
<style lang="less">
    div.word-list{
        div.header{
            text-align: left;
            margin-bottom:20px;
        }
    }
</style>